import { ISimpleEventDetail, Phase } from "interfaces";
import { get, isEmpty } from "lodash";
import { HistoryLogButton } from "components/historyLogButton";
import { useTranslation } from "@refinedev/core";
import { endpointService } from "components/shared/services/endpointService";

interface TicketPhaseProps {
  eventDetailData: ISimpleEventDetail;
  ticketPhases: Phase[];
}
export const TicketPhase = ({
  eventDetailData,
  ticketPhases,
}: TicketPhaseProps) => {
  const { translate } = useTranslation();

  return (
    <div className="box-container p-4">
      <div>
        <div className="grid gap-y-4 sm:grid-cols-6">
          {ticketPhases.map((phase: Phase, index: number) => (
            <div
              className="col-span-full flex flex-col gap-y-2 sm:flex-row items-start justify-between rounded-md border border-gray-300 px-4 py-2.5"
              key={phase.id}
            >
              <div className="flex flex-row flex-wrap self-center">
                {eventDetailData.languages.map((lang, langIndex) => (
                  <p key={lang}>
                    {get(phase, `name.${lang}`)}{" "}
                    {langIndex !== eventDetailData.languages.length - 1 ? (
                      <span className="mx-1.5">/</span>
                    ) : (
                      <></>
                    )}
                  </p>
                ))}
              </div>
              <div className="flex flex-row items-center self-end sm:self-start gap-x-2">
                <span
                  className={`w-fit inline-flex items-center rounded-md px-3 py-1 text-xs font-medium ring-1 ring-inset ${
                    get(phase, "is_active", false)
                      ? "bg-green-100 ring-green-100 text-green-700"
                      : "bg-magnolia-500 text-neutral-800 ring-magnolia-600"
                  }`}
                >
                  {get(phase, "is_active", false) ? translate("active") : translate("in-active")}
                </span>
                {get(phase, "is_active", false) ? (
                  <span
                    className={`w-fit inline-flex items-center rounded-md px-3 py-1 text-xs font-medium ring-1 ring-inset ${
                      get(phase, "hide_in_ui", false)
                        ? "bg-magnolia-500 text-neutral-800 ring-magnolia-600"
                        : "bg-green-100 ring-green-100 text-green-700"
                    }`}
                  >
                    {get(phase, "hide_in_ui", false)
                      ? translate("hide")
                      : translate("show")}
                  </span>
                ) : (
                  <></>
                )}
                <HistoryLogButton
                  className="border-none shadow-none !w-8 !h-8 p-0 text-black shrink-0 focus-visible:outline-none"
                  hideTitle
                  resource={endpointService.getEventEndpoint(
                    "getTicketPhaseHistoryLog",
                    {
                      logId: phase.id ?? "",
                    }
                  )}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="text-center text-sm">
          {isEmpty(ticketPhases) ? <p>{translate("eventSetup.phaseAndTicket.noPhase")}</p> : <></>}
        </div>
      </div>
    </div>
  );
};
